<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>

<!-- Filter modal -->
<div class="modal-overlay" *ngIf="filterPopupVisible" (click)="filterPopupVisible = false">
	<div class="modal-panel" (click)="$event.stopPropagation()">
		<div class="modal-header">
			<span>Filter Racks</span>
			<button class="modal-close" (click)="filterPopupVisible = false"><i class="fal fa-times"></i></button>
		</div>
		<div class="modal-body">
			<div class="rack-checkbox-list">
				<ng-container *ngFor="let location of locations">
					<div class="rack-location-group-header rack-location-group-header--{{ locationCssClass(location) }}">{{ location }}</div>
					<label class="rack-checkbox" *ngFor="let rackGroup of getRackGroupsByLocation(location)">
						<input type="checkbox" [checked]="isRackSelected(rackGroup.rack)" (change)="toggleRack(rackGroup.rack)" />
						<span class="rack-checkbox-label">Rack {{ rackGroup.rack }}</span>
						<span class="rack-checkbox-count">{{ rackGroup.bays.length }} bay{{ rackGroup.bays.length !== 1 ? 's' : '' }}</span>
					</label>
				</ng-container>
			</div>
		</div>
		<div class="modal-footer">
			<button class="modal-btn modal-btn--secondary" (click)="deselectAll()">None</button>
			<button class="modal-btn modal-btn--secondary" (click)="selectAll()">All</button>
			<button class="modal-btn modal-btn--primary" (click)="filterPopupVisible = false">Done</button>
		</div>
	</div>
</div>

<!-- Item detail modal -->
<div class="modal-overlay" *ngIf="itemDetailVisible" (click)="closeItemDetail()">
	<div class="modal-panel item-detail-panel" (click)="$event.stopPropagation()">
		<div class="modal-header">
			<span>{{ selectedItem?.item?.name }}</span>
			<button class="modal-close" (click)="closeItemDetail()"><i class="fal fa-times"></i></button>
		</div>
		<div class="modal-body item-detail-body">

			<div class="detail-loading" *ngIf="itemDetailLoading">
				<i class="fal fa-spinner fa-spin"></i> Loading...
			</div>

			<ng-container *ngIf="!itemDetailLoading && selectedItem">

				<div class="detail-section-title">Details</div>
				<div class="detail-grid">
					<div class="detail-row">
						<span class="detail-label">Item</span>
						<span class="detail-value">{{ selectedItem.item?.name }}</span>
					</div>
					<div class="detail-row">
						<span class="detail-label">Location</span>
						<span class="detail-value">{{ selectedItem.location }}</span>
					</div>
					<div class="detail-row">
						<span class="detail-label">Gauge</span>
						<span class="detail-value">{{ selectedItem.gauge || '—' }}</span>
					</div>
					<div class="detail-row">
						<span class="detail-label">Width</span>
						<span class="detail-value">{{ selectedItem.width || '—' }}</span>
					</div>
					<div class="detail-row">
						<span class="detail-label">Length</span>
						<span class="detail-value">{{ selectedItem.length || '—' }}</span>
					</div>
					<div class="detail-row">
						<span class="detail-label">Quantity</span>
						<span class="detail-value">{{ selectedItem.quantity }}</span>
					</div>
					<div class="detail-row">
						<span class="detail-label">Purchase Log</span>
						<span class="detail-value">
							<ng-container *ngIf="selectedItem.purchaseLog; else noPurchaseLog">
								#{{ selectedItem.purchaseLog.id }}
								<button class="detail-link-btn" (click)="viewPurchaseLog(selectedItem)" title="View purchase log">
									<i class="fal fa-eye"></i>
								</button>
							</ng-container>
							<ng-template #noPurchaseLog>—</ng-template>
						</span>
					</div>
					<ng-container *ngIf="isContractManagement">
					<div class="detail-row">
						<span class="detail-label">Unit Cost</span>
						<span class="detail-value">{{ getStockValue(selectedItem) / (+selectedItem.quantity || 1) | currency:'GBP':'symbol':'1.2-2' }}</span>
					</div>
					<div class="detail-row">
						<span class="detail-label">Est. Value</span>
						<span class="detail-value"><strong>{{ getStockValue(selectedItem) | currency:'GBP':'symbol':'1.2-2' }}</strong></span>
					</div>
				</ng-container>
					<div class="detail-row">
						<span class="detail-label">Supplier</span>
						<span class="detail-value">{{ selectedItem.purchaseLog?.supplier?.name || '—' }}</span>
					</div>
					<div class="detail-row">
						<span class="detail-label">Date Received</span>
						<span class="detail-value">{{ selectedItem.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
					</div>
					<div class="detail-row">
						<span class="detail-label">Days in Stock</span>
						<span class="detail-value">{{ itemAgeDays(selectedItem) }}</span>
					</div>
				</div>

				<div class="detail-section-title detail-section-title--spaced">History</div>
				<table class="history-table">
					<thead>
						<tr>
							<th>Change</th>
							<th>Prev. Location</th>
							<th>New Location</th>
							<th>User</th>
							<th>When</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let h of itemHistory">
							<td>{{ h.changeAmount }}</td>
							<td>{{ h.previousLocation || '—' }}</td>
							<td>{{ h.currentLocation || '—' }}</td>
							<td>{{ h.user?.email }}</td>
							<td>{{ h.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
						</tr>
						<tr *ngIf="itemHistory.length === 0">
							<td colspan="5" class="history-empty">No history recorded</td>
						</tr>
					</tbody>
				</table>

			</ng-container>

		</div>
		<div class="modal-footer">
			<button class="modal-btn modal-btn--secondary" (click)="editStoreItem(selectedItem)" *ngIf="selectedItem">
				<i class="fal fa-pencil"></i> Edit
			</button>
			<button class="modal-btn modal-btn--primary" (click)="closeItemDetail()">Close</button>
		</div>
	</div>
</div>

<div class="store-map-container">

	<div class="store-map-loading" *ngIf="loading">
		<i class="fal fa-spinner fa-spin"></i> Loading stock...
	</div>

	<ng-container *ngIf="!loading">

		<!-- Legend -->
		<div class="legend">
			<span class="legend-item">
				<span class="legend-swatch legend-swatch--normal"></span> < 30 Days
			</span>
			<span class="legend-item">
				<span class="legend-swatch legend-swatch--old"></span> 30–60 days
			</span>
			<span class="legend-item">
				<span class="legend-swatch legend-swatch--very-old"></span> 60+ days
			</span>
		</div>

		<!-- Location filter bar -->
		<div class="location-filter" *ngIf="locations.length > 0">
			<span class="location-filter-label">Site:</span>
			<button
				class="location-chip location-chip--{{ locationCssClass(location) }}"
				[class.location-chip--active]="isLocationFullySelected(location)"
				(click)="toggleLocation(location)"
				*ngFor="let location of locations">
				<span class="location-chip-dot"></span>
				{{ location }}
			</button>
		</div>

		<!-- Active filter summary -->
		<div class="filter-summary" *ngIf="!allSelected">
			<i class="fal fa-filter"></i>
			Showing {{ filteredRackGroups.length }} of {{ rackGroups.length }} racks
			<button class="link-btn" (click)="selectAll()">Show all</button>
			<span class="filter-summary-value" *ngIf="isContractManagement && filteredStockValue > 0">
				&nbsp;· Est. value: <strong>{{ filteredStockValue | currency:'GBP':'symbol':'1.2-2' }}</strong>
			</span>
		</div>

		<!-- Total stock value bar -->
		<div class="stock-value-bar" *ngIf="isContractManagement && totalStockValue > 0 && allSelected">
			<i class="fal fa-coins"></i>
			Total estimated stock value: <strong>{{ totalStockValue | currency:'GBP':'symbol':'1.2-2' }}</strong>
		</div>

		<!-- Rack visualisation -->
		<div class="rack-area" *ngIf="filteredRackGroups.length > 0">
			<div
				class="rack rack--{{ locationCssClass(rackGroup.location) }}"
				*ngFor="let rackGroup of filteredRackGroups">

				<div class="rack-header">
					<div class="rack-header-left">
						<span class="rack-label">Rack {{ rackGroup.rack }}</span>
						<span class="rack-location">{{ rackGroup.location }}</span>
					</div>
					<div class="rack-header-right">
						<span class="rack-count">{{ rackGroup.bays.length }} bay{{ rackGroup.bays.length !== 1 ? 's' : '' }}</span>
						<span class="rack-value" *ngIf="isContractManagement">{{ getRackValue(rackGroup) | currency:'GBP':'symbol':'1.2-2' }}</span>
					</div>
				</div>

				<div class="rack-body">
					<!-- Bays rendered highest → lowest so floor (bay 1) sits at the bottom -->
					<div
						class="bay"
						*ngFor="let bayGroup of rackGroup.bays.slice().reverse()"
						[class.bay--floor]="bayGroup.bay === 1"
						[class.bay--empty]="bayGroup.items.length === 0">

						<div class="bay-label">{{ bayGroup.label }}</div>

						<div class="bay-items">
							<div
								class="stock-item"
								*ngFor="let item of bayGroup.items"
								[class.stock-item--low]="isLowStock(item)"
								[class.stock-item--old]="isOldStock(item)"
								[class.stock-item--very-old]="isVeryOldStock(item)"
								[title]="item.item?.name + ' — Qty: ' + item.quantity + (item.alertQuantity ? ' (Alert: ' + item.alertQuantity + ')' : '') + ' (' + itemAgeDays(item) + ' days)'">
								<button class="stock-item-info" (click)="openItemDetail(item)"><i class="fal fa-info-circle"></i></button>
								<span class="stock-item-name">{{ item.item?.name }}<span class="stock-item-gauge" *ngIf="item.gauge || item.width || item.length"> ({{ formatSize(item) }})</span></span>
								<span class="stock-item-qty">{{ item.quantity }}</span>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>

		<div class="no-data" *ngIf="filteredRackGroups.length === 0">
			<i class="fal fa-box-open"></i>
			<p>No racks selected. <button class="link-btn" (click)="selectAll()">Show all</button></p>
		</div>

		<!-- Unlocated items -->
		<div class="unknown-section" *ngIf="unknownItems.length > 0">
			<div class="unknown-header">
				<span>
					<i class="fal fa-question-circle"></i>
					Unlocated Items ({{ unknownItems.length }})
				</span>
				<span class="unknown-value" *ngIf="isContractManagement">{{ unknownItemsValue | currency:'GBP':'symbol':'1.2-2' }}</span>
			</div>
			<div class="unknown-items">
				<div
					class="stock-item stock-item--unknown"
					*ngFor="let item of unknownItems"
					[class.stock-item--low]="isLowStock(item)"
					[class.stock-item--old]="isOldStock(item)"
					[class.stock-item--very-old]="isVeryOldStock(item)"
					[title]="'Location: ' + (item.location || 'UNKNOWN') + ' (' + itemAgeDays(item) + ' days)'">
					<button class="stock-item-info" (click)="openItemDetail(item)"><i class="fal fa-info-circle"></i></button>
					<span class="stock-item-name">{{ item.item?.name }}<span class="stock-item-gauge" *ngIf="item.gauge || item.width || item.length"> ({{ formatSize(item) }})</span></span>
					<span class="stock-item-qty">{{ item.quantity }}</span>
					<span class="stock-item-loc">{{ item.location || 'UNKNOWN' }}</span>
				</div>
			</div>
		</div>

	</ng-container>

</div>
